import React, { useEffect } from "react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import { useLocation } from "react-router-dom";
import HeroSection from "../../layout/HeroSection";
import Loader from "../../components/other/Loader";
import { pageRoutes } from "../../routes/pageRoutes";
import { useDispatch, useSelector } from "react-redux";
import { fetchServiceDetailById } from "../../redux/action/homeAction";

const ServiceDetail = () => {
  const { id } = useLocation()?.state;
  const dispatch = useDispatch();
  const { serviceDetail, isLoading } = useSelector(
    (state) => state.homeReducer
  );

  useEffect(() => {
    dispatch(fetchServiceDetailById(id));
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div>
      <Header />

      <HeroSection
        label={<h1 class="mb-3">{"Service Detail"}</h1>}
        breadcrumbItems={[
          { name: "Home", path: `${pageRoutes?.home}/` },
          {
            name: "Services",
            path: pageRoutes?.services,
          },
          {
            name: "Service Details",
            path: `${pageRoutes?.home}/`,
          },
        ]}
      />
      <div class="untree_co-section product-section py-5">
        {/* <!-- <h2 class="section-title mb-5 text-center pb-5"><strong>Top Products</strong></h2> --> */}

        <div class="container">
          <div class="row">
            <div class="col-md-10 mx-auto" data-aos-duration="1000">
              <div
                class="ct_service_card pt-4"
                style={{ backgroundColor: "#f5f5f5" }}
              >
                <figure>
                  <div class="ct_service_img">
                    <img
                      src={serviceDetail?.service_image ?? ""}
                      alt="Robotic_img"
                    />
                  </div>

                  {/* <Description text={descriptionText} maxLength={50} /> */}
                  <figcaption>
                    <h4>{serviceDetail?.service_title ?? ""}</h4>

                    <p className="ct_d_block_c ct_reset_text_overflow">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: serviceDetail?.service_description,
                        }}
                      />
                    </p>
                  </figcaption>
                </figure>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ServiceDetail;
